import clsx from 'clsx';
import Button from 'epn-ui/umd/dist/components/Button';

import styles from './RedButton.module.scss';

interface IRedButtonProps {
    formLink: string;
    text: string;
    classnames?: string;
}

const RedButton: React.FC<IRedButtonProps> = ({ classnames = '', formLink, text }) => {
    return (
        <Button
            className={clsx(styles.btn, classnames)}
            size="large"
            type="primary"
            href={formLink}
            target="__blank"
        >
            {text}
        </Button>
    );
};

export default RedButton;
